<div class="form-step-fields__yes-no-grid grid grid-i2">
	@for (optionLabelKey of optionLabelKeys; track optionLabelKey) {
		<tec-item [title]="optionLabelKey | translate" [disabled]="true" [clickeable]="false">
			<tec-list-detail>
				<tec-info-group>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_LABEL_SINGLE_SELECT' | translate }}</span>
				</tec-info-group>
			</tec-list-detail>
		</tec-item>
	}
</div>
